import { styled } from '@mui/material/styles';

const Root = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '100vw',
}));

const Main = styled('main')(({ theme }) => ({
  flexGrow: 2,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  minHeight: '100vh',
  minWidth: '100vw',
  maxWidth: '100vw',
  position: 'relative',
  background: theme.palette.background.default,
  [theme.breakpoints.down('sm')]: {
    width: '98vw',
    overflowX: 'hidden',
  },
}));

export { Main, Root };
